import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import {
  DefaultMenuItem,
  GetContextMenuItemsParams,
  MenuItemDef,
} from 'ag-grid-community'
import { getChildren } from '../../../containers/BulkSheetView/lib/tree'
import store from '../../../../store'
import { requireSave } from '../../../../store/requiredSaveData'
import {
  PROGRAM_PROJECT_REPORT_INPUT_MODE,
  ProgramProjectReportInputMode,
  ProgramProjectReportRow,
  sumProgress,
} from '../model/reportRow'

export const useProgramProjectReportContextMenu = ({
  allRows,
  inputMode,
}: {
  allRows: ProgramProjectReportRow[]
  inputMode: ProgramProjectReportInputMode
}) => {
  const intl = useIntl()

  return useCallback(
    (
      params: GetContextMenuItemsParams<ProgramProjectReportRow>
    ): (DefaultMenuItem | MenuItemDef<ProgramProjectReportRow>)[] => {
      const row = params.node?.data
      const children = row ? getChildren(allRows, row) : []
      const isFreeMode = inputMode === PROGRAM_PROJECT_REPORT_INPUT_MODE.FREE

      return [
        {
          name: intl.formatMessage({
            id: 'programProjectReport.contextMenu.aggregateChildren',
          }),
          disabled: !isFreeMode || !row || children.length === 0,
          action: () => {
            if (!row) return
            row.progress = sumProgress(children)
            params.api.refreshCells({ force: true })
            store.dispatch(requireSave())
          },
        },
      ]
    },
    [allRows, inputMode, intl]
  )
}
